import { defineNuxtPlugin, useState } from "#imports";
import {
  source,
  sourceLength,
  keyStringsEncoded,
  redirectHook
} from "#vuepal-build/trusted-origins";
import { globalWindow, getStrings } from "./../helpers/trustedOrigins.js";
export default defineNuxtPlugin({
  setup(app) {
    if (import.meta.client) {
      let doRedirect = function() {
        getStrings(source, (strings) => {
          if (!globalWindow) throw Error();
          const _location = strings[1];
          const _href = strings[13];
          const redirectTo = strings[14];
          if (import.meta.dev) {
            throw new Error(
              `vuepal trustedOrigins: A redirect to "${redirectTo}" would happen here in the production build. Make sure your current origin is allowed in vuepal.trustedOrigins.origins in nuxt.config.ts`
            );
          }
          if (redirectTo) {
            globalWindow[_location][_href] = redirectTo;
            return;
          }
          throw new Error();
        });
      };
      if (source.length !== sourceLength) {
        throw new Error("Invalid source length.");
      }
      useState(keyStringsEncoded).value = source;
      app.hooks.hook(redirectHook, doRedirect);
    }
  }
});
